import React from "react"
import {FieldGlistGroupProps} from "../../../../../render/glist/glist-group"

export default function FieldUserCompanyRole_GlistGroupModern(props:FieldGlistGroupProps) {

    // Notice: value may be 'null' (string) because while grouping null value is automatically converted to string

    // const option = this._getOption(value);
    const option = props.field._getOption(props.data.value)

    const groupName = _.get(option, 'label', props.field.noValueOptionLabel);

    return <div className="ui5-title-small txt-capitalize">{groupName}</div>;

}
